module.exports = __webpack_public_path__ + "static/media/roastedberries.221e54c6.webp";